export const BASE_URL = 'https://testingapi.kdpfoundation.org/api';
export const Image_URL = 'https://testingapi.kdpfoundation.org';

// Local
// export const BASE_URL = 'https://localhost:44346/api';
// export const Image_URL = 'https://localhost:44346'